import { type InputHTMLAttributes, forwardRef } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
  hint?: string;
};

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { label, error, hint, id, style, ...props },
  ref,
) {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {label && (
        <label
          htmlFor={inputId}
          style={{
            fontSize: 'var(--text-xs)',
            fontWeight: 600,
            color: 'var(--text-secondary)',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
          }}
        >
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        style={{
          height: 36,
          padding: '0 12px',
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--text-sm)',
          color: 'var(--text-primary)',
          background: 'var(--surface-base)',
          border: `1px solid ${error ? 'var(--badge-rejected-text)' : 'var(--border-default)'}`,
          borderRadius: 'var(--radius-md)',
          outline: 'none',
          transition: 'border-color var(--transition-fast)',
          width: '100%',
          ...style,
        }}
        onFocus={(e) => {
          (e.currentTarget as HTMLElement).style.borderColor = error
            ? 'var(--badge-rejected-text)'
            : 'var(--border-focus)';
        }}
        onBlur={(e) => {
          (e.currentTarget as HTMLElement).style.borderColor = error
            ? 'var(--badge-rejected-text)'
            : 'var(--border-default)';
        }}
        {...props}
      />
      {(error ?? hint) && (
        <span
          style={{
            fontSize: 'var(--text-xs)',
            color: error ? 'var(--badge-rejected-text)' : 'var(--text-tertiary)',
          }}
        >
          {error ?? hint}
        </span>
      )}
    </div>
  );
});
